module.exports = __webpack_public_path__ + "img/know_btn.1442ec50.png";